import Bruce from "../images/bruce.webm"
import TheNav from "../Components/navbar";
import SEO from "../Components/SEO";

export default function Return() {
  return (
    <>
      <SEO
        title="Order Complete | Kre8"
        description="Private Kre8 payment return page."
        canonicalPath="/return"
        noindex
      />
      <TheNav />
      <main className="mobile-safe grid min-h-screen place-items-center overflow-hidden bg-[#07060d] px-4 py-20 text-white sm:px-6 lg:px-8">
        <div aria-hidden className="pointer-events-none absolute right-[-6rem] top-24 h-80 w-80 rounded-full bg-[#84ff00]/10 blur-3xl" />
        <div className="relative w-full max-w-3xl overflow-hidden rounded-3xl border border-white/10 bg-white/[0.035] p-6 text-center shadow-[0_30px_100px_-60px_rgba(145,70,255,0.75)] backdrop-blur-xl sm:p-10">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-[#84ff00]">Success</p>
          <h1 className="mt-4 text-3xl font-black tracking-tight text-white sm:text-5xl">
            Your Stripe account has been linked
          </h1>
          <p className="mx-auto mt-5 max-w-2xl text-base leading-7 text-zinc-400 sm:text-lg">
            You may now withdraw your earnings to whichever platform you choose.
          </p>
          <video
            className="mx-auto mt-8 max-h-72 w-full max-w-md rounded-3xl border border-white/10 object-cover"
            src={Bruce}
            autoPlay
            loop
            muted
            playsInline
          />
          <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
            <a
              href="/home"
              className="inline-flex items-center justify-center rounded-full bg-[#84ff00] px-5 py-3 text-sm font-bold text-black transition hover:brightness-110"
            >
              Go back home
            </a>
            <a href="/orders" className="inline-flex items-center justify-center rounded-full border border-white/10 bg-white/[0.04] px-5 py-3 text-sm font-semibold text-white transition hover:bg-white/[0.08]">
              View your orders
            </a>
          </div>
        </div>
      </main>
    </>
  )
}
